import * as React from "react"
import styled from 'styled-components/macro'
import Title from "../../common/Title"
import Subtitle from "../../common/Subtitle";
import ChainlinkLogo from '../../images/PartnersInvestorsIntegrations/Chainlink-Logo-White.svg'
import GMXLogo from '../../images/PartnersInvestorsIntegrations/GMX-logo.svg'
import ArbitrumLogo from '../../images/PartnersInvestorsIntegrations/arbitrum-logo.png'
import DGHLogo from '../../images/PartnersInvestorsIntegrations/draper-goren-holm-logo.png'
import FalconXLogo from '../../images/PartnersInvestorsIntegrations/falconx-logo.svg'
import HarvestFinanceLogo from '../../images/PartnersInvestorsIntegrations/harvest-finance-logo.png'
import MantleLogo from '../../images/PartnersInvestorsIntegrations/mantle-logo.svg'
import GraphLogo from '../../images/PartnersInvestorsIntegrations/graph-logo.svg'
import GraphLogoText from '../../images/PartnersInvestorsIntegrations/the-graph-logo-text.png'
import WWVenturesLogo from '../../images/PartnersInvestorsIntegrations/wwventures-logo.png'
import NGCVenturesLogo from '../../images/PartnersInvestorsIntegrations/NGC-Ventures-logo.png'
import ChainlinkBuildLogo from '../../images/PartnersInvestorsIntegrations/Chainlink-Build-Logo.png'
import RR2Logo from '../../images/PartnersInvestorsIntegrations/RR2-logo.png'
import CoinbaseVenturesLogo from '../../images/PartnersInvestorsIntegrations/coinbase-ventures-logo.png'
import PolygonLogo from '../../images/PartnersInvestorsIntegrations/polygon-logo.png'
import SixthManLogo from '../../images/PartnersInvestorsIntegrations/6th-man-ventures-logo.svg'
import ChainalysisLogo from '../../images/PartnersInvestorsIntegrations/chainalysis-logo.png'
import PendleLogo from '../../images/PartnersInvestorsIntegrations/Pendle-logo.png'
import JonesDAOLogo from '../../images/PartnersInvestorsIntegrations/JonesDAO-logo.png'
import BerachainLogo from '../../images/PartnersInvestorsIntegrations/Berachain-logo.svg'

const FuturePartnersInvestorsIntegrationsWrapper = styled.div`
  width: 100%;
  color: #f9f9f9;
  padding-bottom: 200px;
  max-width: 1100px;
  text-align: center;
  margin: 100px auto 0;
  
  @media screen and (max-width: 880px) {
    > div {
      max-width: 480px;
      margin: 0 auto;
    }
  }
`

const Content = styled.div`
  width: 100%;
  padding: 25px 25px 5px;
  margin: 10px auto 0;
  
  @media screen and (max-width: 1200px) {
    padding: 0;
  }

  @media screen and (max-width: 880px) {
    width: calc(100% - 40px);
    padding: 25px 20px 5px;
  }
`

const StyledSubtitle = styled(Subtitle)`
  font-weight: 200;
  font-size: 16px;
  line-height: 25px;
  margin-top: -16px;
  margin-bottom: 30px;
  width: 70%;
  margin-left: 15%;
  
  @media screen and (max-width: 880px) {
    width: 100%;
    margin-left: 0;
  }
`

const ItemsWrapper = styled.div`
  width: 100%;
`

const Item = styled.div`
  display: inline-block;
  vertical-align: top;
  height: 60px;
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
  user-select: none;
  color: white;
  margin: 20px;

  img {
    height: 100%;
    color: white;
  }
  
  svg {
    height: 100%;
    color: white;
  }
  
  :hover {
    transform: scale(1.1);
  }
  
  @media screen and (max-width: 880px) {
    height: 50px;
    display: block;
  }
`

// markup
const FuturePartnersInvestorsIntegrations = () => {

  return (
    <FuturePartnersInvestorsIntegrationsWrapper>
      <div>
        <Content>
          <Title style={{ fontSize: '36px', marginBottom: '25px' }}>
            Partners, Investors, & Integrations
          </Title>
          <StyledSubtitle>
            We've had the privilege of working with some of the best in the industry, and we have even more in the works. If you'd like to work with us in some capacity, reach out on our socials.
          </StyledSubtitle>
          <ItemsWrapper>
            <a href={"https://chain.link/"} target={"_blank"}>
              <Item>
                <img src={ChainlinkLogo} alt="Chainlink Logo" />
              </Item>
            </a>
            <a href={"https://arbitrum.io/"} target={"_blank"}>
              <Item>
                <img style={{ height: '110%' }} src={ArbitrumLogo} alt="Arbitrum Logo" />
              </Item>
            </a>
            <a href={"https://drapergorenholm.com/"} target={"_blank"}>
              <Item>
                <img src={DGHLogo} alt="Draper Goren Holm Logo" />
              </Item>
            </a>
            <a href={"https://falconx.io/"} target={"_blank"}>
              <Item>
                <img style={{ filter: 'invert(1)', height: '64%', marginTop: '10px' }} src={FalconXLogo} alt="FalconX Logo" />
              </Item>
            </a>
            <a href={"https://gmx.io/"} target={"_blank"}>
              <Item>
                <img style={{ filter: 'brightness(100)', height: '64%', marginTop: '10px' }} src={GMXLogo} alt="GMX Logo" />
              </Item>
            </a>
            {/*<a href={"https://harvest.finance/"} target={"_blank"}>
              <Item>
                <img src={HarvestFinanceLogo} alt="Harvest Finance Logo" />
              </Item>
            </a>*/}
            <a href={"https://mantle.xyz/"} target={"_blank"}>
              <Item>
                <img style={{ filter: 'brightness(0) invert(1)' }} src={MantleLogo} alt="Mantle Logo" />
              </Item>
            </a>
            <a href={"https://thegraph.com/"} target={"_blank"}>
              <Item>
                <img style={{ filter: 'invert(1)' }} src={GraphLogo} alt="Chainlink Logo" />
                <img style={{ height: '64%', marginBottom: '11px', marginLeft: '-6px' }} src={GraphLogoText} alt="Chainlink Logo" />
              </Item>
            </a>
            <a href={"https://www.wwventures.io/"} target={"_blank"}>
              <Item>
                <img style={{ width: '100%', maxWidth: '420px', height: 'auto', transform: 'translateY(20%)' }} src={WWVenturesLogo} alt="WW Ventures Logo" />
              </Item>
            </a>
            <a href={"https://ngc.fund/"} target={"_blank"}>
              <Item style={{ marginLeft: '-4%', marginRight: '-5%' }}>
                <img style={{ height: '240%', transform: 'translateY(-32%)' }} src={NGCVenturesLogo} alt="NGC Ventures Logo" />
              </Item>
            </a>
            <a href={"https://chain.link/economics/build-program"} target={"_blank"}>
              <Item>
                <img style={{ height: '120%', transform: 'translateY(-10%)' }} src={ChainlinkBuildLogo} alt="Chainlink Build Logo" />
              </Item>
            </a>
            <a href={"https://rr2.capital/"} target={"_blank"}>
              <Item>
                <img src={RR2Logo} alt="RR2 Logo" />
              </Item>
            </a>
            <a href={"https://www.coinbase.com/ventures"} target={"_blank"}>
              <Item>
                <img  style={{ filter: 'brightness(0) invert(1)' }} src={CoinbaseVenturesLogo} alt="Coinbase Ventures Logo" />
              </Item>
            </a>
            <a href={"https://polygon.technology/"} target={"_blank"}>
              <Item>
                <img style={{ height: '150%', transform: 'translateY(-18%)', filter: 'brightness(0) invert(1)' }} src={PolygonLogo} alt="Polygon Logo" />
              </Item>
            </a>
            <a href={"https://6thman.ventures/"} target={"_blank"}>
              <Item>
                <img src={SixthManLogo} alt="6th Man Ventures Logo" />
              </Item>
            </a>
            <a href={"https://www.chainalysis.com/"} target={"_blank"}>
              <Item>
                <img style={{ height: '250%', transform: 'translateY(-32%)', filter: 'brightness(0) invert(1)' }} src={ChainalysisLogo} alt="Chainalysis Logo" />
              </Item>
            </a>
            <a href={"https://www.pendle.finance/"} target={"_blank"}>
              <Item>
                <img style={{ height: '150%', transform: 'translateY(-18%)' }} src={PendleLogo} alt="Pendle Logo" />
              </Item>
            </a>
            <a href={"https://www.jonesdao.io/"} target={"_blank"}>
              <Item>
                <img style={{ filter: 'brightness(0) invert(1)' }} src={JonesDAOLogo} alt="Jones DAO Logo" />
              </Item>
            </a>
            <a href={"https://www.berachain.com/"} target={"_blank"}>
              <Item>
                <img src={BerachainLogo} alt="Berachain Logo" />
              </Item>
            </a>
          </ItemsWrapper>
        </Content>
      </div>
    </FuturePartnersInvestorsIntegrationsWrapper>
  )
}

export default FuturePartnersInvestorsIntegrations
